import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { API_URL } from "../../../constants/index";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { useNavigate } from 'react-router-dom';

const LeaveEncashmentReport = () => {
  const [expenseData, setExpenseData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [empList, setEmpList] = useState([]);
  const [year, setYear] = useState([]);
  const [respStatus, setRepStatus] = useState(0);
  const [filterFormData, setFilterData] = useState([]);
  const [apiStatus, SetApiStatus] = useState();

  const columns = {
    EmployeeName: { text: "Employee", visible: true },
    CalendarName: { text: "Calendar", align: "center", visible: true },
    LeaveName: { text: "Leave", align: "center", visible: true },
    LeaveBalance: { text: "Leave Balance", align: "end", visible: true },
    LeaveCarryForward: { text: "Leave Carry Forward", align: "end", visible: true },
    LeaveEncash: { text: "Leave Encash", align: "end", visible: true },
    EncashMonthame: { text: "Encash Month", align: "center", visible: true },
    EncashAmountCalculated: { text: "Encash Amount", align: "center", visible: true },
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    fetchLeaveEncashReport();
    dispatch(updateNavbarHeading("Leave Encashment Report"));
  }, []);

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const fetchLeaveEncashReport = async () => {
    setExpenseData([])
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/2?P_EmployeeID=&P_CalendarID=&P_EncashMonthID=0`
      );
      if (response.status === 200) {
        SetApiStatus(response?.status);
        const expenseData = response?.data?.data.reverse();
        setExpenseData(expenseData?.map(o => ({
  ...o,
  LeaveBalance: (+o?.LeaveBalance || 0).toFixed(2),
  LeaveCarryForward: (+o?.LeaveCarryForward || 0).toFixed(2),
  LeaveEncash: (+o?.LeaveEncash || 0).toFixed(2),
})));


        // Employee List:o.
        const emList = response?.data?.employees?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmpList(emList);

        //   Year List
        const YearList = response?.data?.years?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setYear(YearList.reverse());
        setRepStatus(response.status);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };


  const handleGetData = async () => {
    SetApiStatus(undefined)
    setExpenseData([])
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/2?P_EmployeeID=${filterFormData.find((o) => o.label === "Employee")
          ? filterFormData.find((o) => o.label === "Employee").value
          : 0
        }&P_CalendarID=${filterFormData.find((o) => o.label === "Year")
          ? filterFormData.find((o) => o.label === "Year").value
          : 0
        }&P_EncashMonthID=0`
      );
      if (response.status === 200) {
        SetApiStatus(response?.status);
        const expenseData = response?.data?.data;
        setExpenseData(expenseData.reverse());

        // Employee List
        const emList = response?.data?.employees?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmpList(emList);

        //   Year List
        const YearList = response?.data?.years?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setYear(YearList.reverse());
        setRepStatus(response.status);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };
  const formDatas = [
    { name: "Employee", type: "Select", options: [...empList] },
    { name: "Year", type: "Select", options: [...year] },
  ];

  const handleEdit = (id) => {
    navigate(`/leave-encashment/edit/${id.ID}`)
  }



  const handleReset = () => {
    setFilterData([])
    setExpenseData([])
    fetchLeaveEncashReport()
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={expenseData}
              columns={columns}
              itemsPerPage={10}
              isSorting={true}
              showIcon2={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              searchTerm={searchTerm}
              responseStatus={respStatus}
              handleReset={handleReset}
              isActionRequired={true}
              setSearchTerm={setSearchTerm}
              isFilterRequired={true}
              formDatas={formDatas}
              handleGetData={handleGetData}
              handleChange={handleChange}
              handleIcon2={handleEdit}
              filterFormData={filterFormData}
              icons={{
                Icon2: <i class="bi bi-pencil-square"></i>,
                Icon2Text: "Edit",
                Icon2Flag: "canEdit",
              }}
            />
          </div>
        </div>

      </div>
    </>
  );
};

export default LeaveEncashmentReport;
